import { lightFormat, parseISO } from 'date-fns';

import { FIELD_KEYS } from '_constants/forms';

export const parsePhysicalInfo = (productDetails = {}) => {
  return {
    [FIELD_KEYS.gender]: productDetails[FIELD_KEYS.gender] || null,
    [FIELD_KEYS.dateOfBirth]: productDetails[FIELD_KEYS.dateOfBirth]
      ? parseISO(productDetails[FIELD_KEYS.dateOfBirth])
      : new Date(),
    [FIELD_KEYS.heightFt]: productDetails[FIELD_KEYS.heightFt] || null,
    [FIELD_KEYS.heightIn]: productDetails[FIELD_KEYS.heightIn] || null,
    [FIELD_KEYS.weightLbs]: productDetails[FIELD_KEYS.weightLbs] || null,
    [FIELD_KEYS.desiredWeightLbs]: productDetails[FIELD_KEYS.desiredWeightLbs] || null,
  };
};

export const parseShippingAddress = (orderDetails = {}) => {
  return {
    [FIELD_KEYS.shippingAddressAddress1]: orderDetails?.shippingAddress?.address1 || null,
    [FIELD_KEYS.shippingAddressCity]: orderDetails?.shippingAddress?.city || null,
    [FIELD_KEYS.shippingAddressState]: orderDetails?.shippingAddress?.state || null,
    [FIELD_KEYS.shippingAddressZip]: orderDetails?.shippingAddress?.zip || null,
  };
};

export const mergeOrderBody = (orderDetails = {}, values = {}) => {
  return {
    ...orderDetails,
    shippingAddress: {
      address1: values[FIELD_KEYS.shippingAddressAddress1],
      address2: null,
      city: values[FIELD_KEYS.shippingAddressCity],
      state: values[FIELD_KEYS.shippingAddressState],
      zip: values[FIELD_KEYS.shippingAddressZip],
      country: 'US',
      county: null,
      permanent: true,
    },
  };
};

export const mergeProductBody = (productDetails = {}, values = {}) => {
  return {
    ...productDetails,
    ...values,
    [FIELD_KEYS.dateOfBirth]: lightFormat(values[FIELD_KEYS.dateOfBirth], 'yyyy-MM-dd'),
    [FIELD_KEYS.heightFt]: parseInt(values[FIELD_KEYS.heightFt]),
    [FIELD_KEYS.heightIn]: parseInt(values[FIELD_KEYS.heightIn]),
    [FIELD_KEYS.weightLbs]: parseInt(values[FIELD_KEYS.weightLbs]),
    [FIELD_KEYS.desiredWeightLbs]: parseInt(values[FIELD_KEYS.desiredWeightLbs]),
  };
};

export const convertNumericValues = (values = {}) => {
  return {
    ...values,
    [FIELD_KEYS.heightFt]: parseInt(values[FIELD_KEYS.heightFt]),
    [FIELD_KEYS.heightIn]: parseInt(values[FIELD_KEYS.heightIn]),
    [FIELD_KEYS.weightLbs]: parseInt(values[FIELD_KEYS.weightLbs]),
    [FIELD_KEYS.desiredWeightLbs]: parseInt(values[FIELD_KEYS.desiredWeightLbs]),
  };
};
